import { render, staticRenderFns } from "./ButtonStyle.vue?vue&type=template&id=185f7ab1&scoped=true&"
import script from "./ButtonStyle.vue?vue&type=script&lang=ts&"
export * from "./ButtonStyle.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonStyle.vue?vue&type=style&index=0&id=185f7ab1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185f7ab1",
  null
  
)

export default component.exports